module.exports = __webpack_public_path__ + "static/media/capa-emissor-mobile.3e095681.png";